(()=>{'use strict';
 const root=document.querySelector('.estate-events-page');if(!root)return;
 const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
 // Exactly the Collections / About Us navbar and mobile-menu mechanism.
 const navToggle=root.querySelector('.collections-page__menu-toggle');
 const mobileNav=root.querySelector('#collections-mobile-menu');
 if(navToggle&&mobileNav){
   const setOpen=open=>{mobileNav.hidden=!open;navToggle.setAttribute('aria-expanded',String(open));navToggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');};
   navToggle.addEventListener('click',()=>setOpen(mobileNav.hidden));
   mobileNav.addEventListener('click',e=>{if(e.target.closest('a'))setOpen(false)});
   document.addEventListener('keydown',e=>{if(e.key==='Escape')setOpen(false)});
   document.addEventListener('pointerdown',e=>{if(!mobileNav.hidden&&!mobileNav.contains(e.target)&&!navToggle.contains(e.target))setOpen(false)});
 }
 // Scroll animation runs only if IntersectionObserver is supported and motion is allowed.
 const targets=[...root.querySelectorAll('[data-events-reveal]')];
 if('IntersectionObserver'in window&&!reduce.matches){
   const observer=new IntersectionObserver(entries=>{
     entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('events-is-visible');observer.unobserve(entry.target)}})
   },{threshold:.07,rootMargin:'0px 0px -32px 0px'});
   for(const t of targets)observer.observe(t);
   requestAnimationFrame(()=>root.classList.add('events-motion-ready'));
 }
 const header=root.querySelector('.collections-page__header');
 const footerNav=root.querySelector('#final-footer .final-footer__links');
 const heroPhoto=root.querySelector('.events-hero__photo');
 let queued=false;
 const update=()=>{
   if(queued)return;queued=true;
   requestAnimationFrame(()=>{
     queued=false;
     if(header&&footerNav){const r=footerNav.getBoundingClientRect();header.classList.toggle('is-footer-exit',r.top<=innerHeight&&r.bottom>0)}
     if(!reduce.matches&&heroPhoto&&innerWidth>720){
       const h=heroPhoto.closest('.events-hero').getBoundingClientRect();
       const offset=Math.max(0,Math.min(1,(-h.top+123)/Math.max(1,h.height)));
       heroPhoto.style.translate=`0 ${Math.round(offset*32)}px`;
     }
   });
 };
 addEventListener('scroll',update,{passive:true});addEventListener('resize',update,{passive:true});addEventListener('pageshow',update);update();
})();
